/**
 * 人员管理
 */
import request from '@/utils/request'

const urlApi = {
  list: '/index/system/user/getList',
  add: '/index/system/user/add',
  edit: '/index/system/user/edit',
  del: '/index/system/user/del',
  editPassword: '/index/system/user/editPassword',
  simulateLogin: '/index/system/user/simulateLogin'
}

/**
 * 获取人员列表
 * @returns {*}
 */
export function userList (parameter) {
  return request({
    url: urlApi.list,
    method: 'post',
    params: parameter
  })
}

/**
 * 添加人员
 * @returns {*}
 */
export function addUser (parameter) {
  return request({
    url: urlApi.add,
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑人员
 * @returns {*}
 */
export function editUser (parameter) {
  return request({
    url: urlApi.edit,
    method: 'post',
    data: parameter
  })
}

/**
 * 删除人员
 * @returns {*}
 */
export function delUser (parameter) {
  return request({
    url: urlApi.del,
    method: 'get',
    params: parameter
  })
}

/**
 * 修改密码
 * @returns {*}
 */
export function editPassword (parameter) {
  return request({
    url: urlApi.editPassword,
    method: 'post',
    data: parameter
  })
}

/**
 * 模拟登入
 * parameter = {user_id:1}
 * @returns {*}
 */
export function simulateLogin (parameter) {
  return request({
    url: urlApi.simulateLogin,
    method: 'get',
    params: parameter
  })
}
